export const SET_USER_INFO = 'setUserInfo';
export const SET_TOKEN = 'setToken';
export const SET_LNG = 'setLng';



// WEBPACK FOOTER //
// ./src/store/mutations/type.js